import { DrugSource } from "@/models/Drug/DrugProduct";
import { History } from "@/models/History";

/** Which per-plan drug rule an entry represents (mirrors the backend PlanDrugListType). */
export enum PlanDrugListType {
    /** Allow list: when enforced, only drugs on this list may be billed to the plan. */
    Approved = 0,
    /** Deny list: when enforced, drugs on this list may not be billed to the plan. */
    Blocked = 1,
}

/**
 * A single per-plan drug billing rule. Keyed by (packageId, drugSource) — the same drug identity used at claim time
 * — so an entry matches the drug actually being billed. An Approved entry is enforced only when the plan opts in
 * (Plan.enforceApprovedDrugList) and the tenant enables Configuration.enforceApprovedDrugList; a Blocked entry only
 * when the plan opts in (Plan.enforceBlockedDrugList) and the tenant enables Configuration.enforceBlockedDrugList.
 */
export interface PlanDrugList {
    id: number;
    planId: number;
    listType: PlanDrugListType;
    drugSource: DrugSource;
    packageId: number;
    drugName?: string | null;
    ndc?: string | null;
    /** Inclusive lower bound; null = effective from the start. ISO date string. */
    effectiveDate?: string | null;
    /** Exclusive upper bound (drug falls off on this date); null = never expires. ISO date string. */
    expirationDate?: string | null;
    active: boolean;
    created?: string;
    createdBy?: string;
    updated?: string;
    updatedBy?: string;
}

/** Audit-history row for a plan drug-list entry. Carries a server-derived action so the UI need not parse the row. */
export interface PlanDrugListHistory extends History {
    /** "Removed" for a soft-delete, otherwise "Added / Updated". */
    action?: string | null;
}
